import { Controller } from "stimulus";
import dispatchCustomEvent from "../../functions/dispatchCustomEvent.js";

export default class extends Controller {
  static get values() {
    return { multiple: Boolean };
  }

  reflect(event) {
    const { value } = event.detail;

    this.element.value = value;
    this.element.setAttribute("value", value);

    if (this.multipleValue) {
      this.renderEntries(value);
    }

    dispatchCustomEvent(this.element, "change");
  }

  // A multiple field posts one hidden input per comma-separated entry, in the mirror's order,
  // under the field's own name; the disabled field itself never posts
  renderEntries(value) {
    this.entryInputs?.forEach((input) => input.remove());
    this.entryInputs = value.split(",").filter(Boolean).map((entry) => this.hiddenInput(entry));

    this.element.after(...this.entryInputs);
  }

  hiddenInput(value) {
    const input = document.createElement("input");

    input.type = "hidden";
    input.name = this.element.name;
    input.value = value;

    return input;
  }
}
